import request from "@/utils/request";

export default function agentEditMonthlyDate(data) {
  return request({
    url: `/device/memberMonthly/agentEditMonthlyDate`,
    method: "POST",
    data,
  });
}
